<template>
  <ValidationProvider
    ref="customer"
    v-slot="{ errors }"
    name="customer"
    rules="required"
    :vid="vCustomer"
  >
    <BFormGroup
      label-class="font-weight-bolder"
      class="mb-0"
      :label-for="vCustomer"
    >
      <v-select
        v-model="proxyValue"
        placeholder="search customer here"
        label="customer_name"
        clearable
        append-to-body
        select-on-tab
        :input-id="vCustomer"
        :options="filteredCustomers"
        :loading="fetching.customers"
        :disabled="fetching.customers"
        :tabindex="(index + 1)"
        :map-keydown="mapKeyDown"
        :calculate-position="calculateDropPosition"
        :class="['border-0', { 'is-invalid': errors.length > 0 }]"
        @search="searchCustomers"
        @option:selected="() => $emit('selected', proxyValue, index)"
      >
        <template #selected-option="{ customer_name }">
          <div
            class="text-break text-wrap"
            style="font-size: 13px;"
            v-text="customer_name"
          />
        </template>

        <template #option="{ customer_name }">
          <div
            class="text-break text-wrap"
            style="font-size: 13px;"
            v-text="customer_name"
          />
        </template>

        <template #no-options="">
          no available customer
        </template>
      </v-select>
      <div
        v-if="(errors.length > 0)"
        class="invalid-feedback"
        v-text="errors[0]"
      />
    </BFormGroup>
  </ValidationProvider>
</template>
<script>
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'
import MCustomers from '@/mixins/accounts/customers'

export default {
  name: 'ASMMemosCustomer',

  mixins: [
    MISC,
    FORMATTER,
    MCustomers
  ],

  props: {
    value: {
      type: [String, Number, Object],
      default: () => ''
    },
    index: {
      type: Number,
      default: () => 0,
      required: true
    },
    rows: {
      type: Array,
      default: () => ([])
    },
    item: {
      type: Object,
      default: () => null
    }
  },

  emits: [
    'input',
    'selected'
  ],

  data () {
    return {
      selected: {
        cluster: {
          id: ''
        }
      },
      proxyValue: null
    }
  },

  computed: {
    vCustomer () {
      return `customer_memos.${this.index}.customer`
    },

    filteredCustomers () {
      const fso = this.item?.officer || null
      const customer = this.proxyValue || null

      const customers = this.rows.filter(
        row => {
          const rowFso = row.officer || null
          const hasCustomer = row?.customer?.id

          const isSameFso = String(rowFso?.id) === String(fso?.id)
          const isSameCluster = String(row?.customer?.cluster_id) === String(this.selected.cluster.id)
          const isNotStaff = String(row?.customer?.customer_name || '').toUpperCase().indexOf('STAFF') < 0

          return isSameFso && isSameCluster && hasCustomer && isNotStaff
        }
      ).map(row => row.customer?.id)

      return this.options.customers.filter(
        option => !customers.includes(option.id) || (customer?.id === option.id)
      )
    }
  },

  watch: {
    'item.cluster' (cluster) {
      this.selected.cluster = {
        id: cluster
      }

      if (cluster) {
        this.getCustomers(this)
      } else {
        this.proxyValue = null
        this.options.customers = []
      }
    },

    'item.officer' (fso) {
      if (!fso?.id) {
        this.options.customers = []
      }
    },

    value (val) {
      this.proxyValue = val
    },

    proxyValue (val) {
      this.$emit('input', val)
    }
  },

  methods: {

    mapKeyDown (map, context) {
      return {
        ...map,
        // 8: ({ target }) => {
        //   if (target.value === null || target.value === '') {
        //     this.removed()
        //   }
        //   return context.maybeDeleteValue()
        // },
        9: () => {
          if (context.open) {
            return context.onTab()
          }

          return null
        },
        13: evt => {
          evt.preventDefault()
          return context.typeAheadSelect()
        }
      }
    }

    // removed () {
    //   this.$emit('removed', this.item, this.index, true)
    // },
  }
}
</script>
<style scoped>
.v-select {
  background: transparent;
}
</style>
